const noop = () => { };
const noopReturn = (v) => v;

export { noop, noopReturn };
